import { AbilityBuilder } from '@casl/ability'

const subjectName = subject =>
  !subject || typeof subject === 'string' ? subject : subject.__type

export default user => {
  return AbilityBuilder.define({ subjectName }, (can, cannot) => {
    if (!user) return

    if (permitidoLiberarAutomaticamenteConsulta(user)) {
      can('read', 'permitidoLiberarAutomaticamenteConsulta')
    }

    if (user.realm === 'admin') {
      can('manage', 'all')
      cannot('create', 'solicitacoes')
      cannot('create', 'tarefa')
      cannot(['remove', 'update'], 'usuarios')
      can('update', 'usuarios', 'senha', { id: user.id })
      cannot('remove', 'solicitacoesAnalista')
      cannot('remove', 'centrosCusto')
      cannot(['create', 'remove'], 'mercadorias')
      cannot('remove', 'metas')
      cannot('manage', 'solicitacoesEmbarcador')
      cannot('manage', 'tarefasEmbarcador')
    }
    if (user.realm === 'gestor') {
      can('manage', 'lerMensagem')
      can('manage', 'tarefa')
      can('manage', 'admin')
      can('manage', 'solicitacoes')
      can('manage', 'paineis-solicitacoes')
      can('manage', ['paineis-tarefas-viagem', 'paineis-tarefas'])
      can('manage', [
        'paineis-solicitacoes-tempo-real',
        'paineis-solicitacoes-tempo-gerais',
        'paineis-solicitacoes-tempo-solicitacao'
      ])
      can('manage', ['bloqueio-manual-kmm', 'blacklist-kmm'])
      can('manage', ['consultaHistorico', 'solicitacoesHistorico'])
      cannot('read', ['admin', 'solicitacoesHistorico'])
      cannot('create', ['tarefa', 'solicitacoes'])
    }
    if (user.realm === 'analista') {
      can('manage', ['solicitacoesAnalista'])
      can(['update'], ['solicitacoes'])
      cannot('remove', 'solicitacoesAnalista')
      can(['read'], ['solicitacoesHistorico'])
      can(['read'], ['consultaHistorico'])
      can('manage', ['lerMensagem'])
      can('manage', ['bloqueio-manual-kmm', 'blacklist-kmm'])
    }
    if (user.realm === 'analista_2') {
      can('manage', ['solicitacoesAnalista'])
      can(['update', 'read'], ['solicitacoes'])
      can('manage', 'usuarios')
      cannot('remove', 'solicitacoesAnalista')
      can(['read'], ['solicitacoesHistorico'])
      can('manage', 'relatorios')
      can(['read'], ['paineis-solicitacoes', 'paineis-solicitacoes-tempo-real'])
      can(['read'], ['consultaHistorico'])
      can('manage', ['lerMensagem'])
      can('manage', ['bloqueio-manual-kmm', 'blacklist-kmm'])
    }
    if (user.realm === 'analista_op') {
      can(['update'], ['solicitacoes'])
      can('read', 'tarefasAnalista')
      can(['update'], ['tarefas'])
      can(
        ['read'],
        ['consultaHistorico', 'solicitacoesAnalista', 'solicitacoesHistorico']
      )
      can('update', 'tarefa')
      can('read', ['bloqueio-manual-kmm', 'blacklist-kmm'])
      can('manage', ['lerMensagem'])
    }
    if (user.realm === 'analista_op_2') {
      can(['update'], ['solicitacoes'])
      can(['update'], ['tarefas'])
      can(['read'], ['tarefa', 'tarefasAnalista'])
      can(
        ['read'],
        ['consultaHistorico', 'solicitacoesAnalista', 'solicitacoesHistorico']
      )
      can('update', 'tarefa')
      can('read', ['bloqueio-manual-kmm', 'blacklist-kmm'])
      can('manage', ['lerMensagem'])
    }
    if (user.realm === 'embarcador') {
      can('manage', ['solicitacoesEmbarcador'])
      can('manage', 'tarefasEmbarcador')
      cannot('remove', ['solicitacoesEmbarcador'])
      can(['read'], ['consultaHistorico'])
      can('manage', ['lerMensagem'])
    }
    if (user.realm === 'usuario_consulta') {
      can(['read'], ['solicitacoes'])
      can(['read'], ['consultaHistorico'])
      can('read', 'relatorios')
      can('manage', ['lerMensagem'])
      can('read', ['bloqueio-manual-kmm', 'blacklist-kmm'])
    }
  })
}

function permitidoLiberarAutomaticamenteConsulta(usuario) {
  // TODO liberar somente para admin no primeiro momento
  const possuiRolePermitidaLiberarAutomaticamente = [
    'admin'
    // 'analista',
    // 'analista_2',
    // 'analista_op',
    // 'analista_op_2'
  ].includes(usuario.realm)
  const possuiFlagLiberarAutomaticamente = !!usuario.liberarAutomaticamenteConsulta

  if (
    possuiRolePermitidaLiberarAutomaticamente ||
    possuiFlagLiberarAutomaticamente
  ) {
    return true
  }

  return false
}
